import { render, staticRenderFns } from "./rolemanage.vue?vue&type=template&id=f565fc04&scoped=true&"
import script from "./rolemanage.vue?vue&type=script&lang=js&"
export * from "./rolemanage.vue?vue&type=script&lang=js&"
import style0 from "./rolemanage.vue?vue&type=style&index=0&id=f565fc04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f565fc04",
  null
  
)

export default component.exports